import { render, staticRenderFns } from "./editFixedAsset.vue?vue&type=template&id=4ebb4a9f&scoped=true&"
import script from "./editFixedAsset.vue?vue&type=script&lang=js&"
export * from "./editFixedAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebb4a9f",
  null
  
)

export default component.exports